import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import domReady from '@wordpress/dom-ready';

window.Swiper = Swiper;

domReady(() => {
  document.querySelectorAll('[data-component="slider"]').forEach((sliderEl) => {
    new Swiper(sliderEl, {
      autoHeight: true,
      speed: 700,
      loop: true,
      navigation: {
        nextEl: sliderEl.querySelector('.slider-control.next'),
        prevEl: sliderEl.querySelector('.slider-control.prev'),
      },
    });
  });

  document.querySelectorAll('[data-component="carrousel"]').forEach((carrouselEl) => {
    new Swiper(carrouselEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      speed: 700,
      navigation: {
        nextEl: carrouselEl.querySelector('.slider-control.next'),
        prevEl: carrouselEl.querySelector('.slider-control.prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
});
